import { render, staticRenderFns } from "./magicitem.vue?vue&type=template&id=10f1aa11&"
import script from "./magicitem.vue?vue&type=script&lang=js&"
export * from "./magicitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/84/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f1aa11')) {
      api.createRecord('10f1aa11', component.options)
    } else {
      api.reload('10f1aa11', component.options)
    }
    module.hot.accept("./magicitem.vue?vue&type=template&id=10f1aa11&", function () {
      api.rerender('10f1aa11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/magicitem.vue"
export default component.exports